<div *ngIf="mileageRate" class="m-1" style="width: 1500px">
    <div class="d-flex flex-row">
        <div class="m-1">
            <label>Mileage Rate</label>
            <dx-number-box *ngIf="mileageRate" [(value)]="mileageRate.decimalValue" [format]="{ type: 'currency', precision: 2 }" [width]="'100px'"></dx-number-box>
        </div>
        <div class="m-1">
            <label>Discount Mileage Rate</label>
            <dx-number-box *ngIf="discountMileageRate" [(value)]="discountMileageRate.decimalValue" [format]="{ type: 'currency', precision: 2 }" [width]="'150px'"></dx-number-box>
        </div>
        <div class="m-1">
            <label>Lead Time</label>
            <dx-number-box *ngIf="leadTime" [(value)]="leadTime.intValue" [width]="'100px'"></dx-number-box>
        </div>
        <div class="m-1">
            <label>Build Lead Time</label>
            <dx-number-box *ngIf="buildLeadTime" [(value)]="buildLeadTime.intValue" [width]="'100px'"></dx-number-box>
        </div>
        <div class="m-1">
            <label>Months Until Dealer Inactive</label>
            <dx-number-box *ngIf="dealerInactiveMonths" [(value)]="dealerInactiveMonths.intValue" [width]="'180px'"></dx-number-box>
        </div>
        <div class="m-1">
            <label>OnTime Target Percent</label>
            <dx-number-box *ngIf="onTimeTargetPercent" [(value)]="onTimeTargetPercent.decimalValue" [width]="'180px'"></dx-number-box>
        </div>
        <div class="m-1">
            <label>Daily Production Capacity</label>
            <dx-number-box *ngIf="dailyProductionCapacity" [(value)]="dailyProductionCapacity.intValue" [width]="'160px'"></dx-number-box>
        </div>
        <div class="m-1" style="white-space: nowrap">
            <label class="form-label fw-bold">Upload Trip Record HTML</label>
            <dx-file-uploader
                name="fileUpload"
                selectButtonText="Select HTML File"
                accept=".html"
                uploadMode="instantly"
                [showFileList]="true"
                [multiple]="false"
                [uploadUrl]="tripRecordUploadUrl"
                [uploadHeaders]="uploadHeader"
                (onUploadStarted)="tripRecordUploadStarted()"
                (onUploadError)="tripRecordUploadError()"
                (onUploaded)="tripRecordUploaded()"
            ></dx-file-uploader>
            <div *ngIf="driverTripRecordUrlLastUpdate?.stringValue" class="mt-1">Last Updated: {{ driverTripRecordUrlLastUpdate.stringValue }}</div>
        </div>
    </div>
    <div class="mt-3 ms-1" style="min-height: 30px">
        <button *ngIf="hasChanges()" class="btn btn-sm btn-primary" (click)="save()">Save</button>
        <button *ngIf="hasChanges()" class="btn btn-sm btn-danger ms-2" (click)="cancel()">Cancel</button>
    </div>
    <dx-select-box [(value)]="entityType" [items]="entityTypes" [searchEnabled]="true" (onValueChanged)="entityTypeValueChanged($event)" class="mt-3" width="250px"></dx-select-box>
</div>
<div class="flex-fill d-flex flex-column">
    <div class="m-1 grid-fill" *ngIf="entities" style="max-width: 1050px">
        <dx-data-grid
            #dataGrid
            [dataSource]="entities"
            [columns]="gridColumns"
            keyExpr="id"
            [wordWrapEnabled]="true"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onCellDblClick)="rowDoubleClick($event)"
        >
            <dxo-filter-row [visible]="!allowReorder"></dxo-filter-row>
            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-row-dragging [allowReordering]="allowReorder" [onReorder]="onReorder" [showDragIcons]="false"></dxo-row-dragging>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button class="btn btn-success" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0" (click)="open(dataGrid.instance.getSelectedRowsData()[0])">
                    Open
                </button>
                <button class="btn btn-secondary ms-2" (click)="open()">New</button>
                <button
                    class="btn btn-danger ms-5"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                    (click)="delete(dataGrid.instance.getSelectedRowsData()[0])"
                    *ngIf="allowDelete"
                >
                    Delete
                </button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="entities" class="me-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
